/**
 * 员工角色管理
 */

import StoreDecorator, {
  Action,
  Mutation,
  Getter,
  AutoLoading
} from '@acgn/herm/lib/store-decorator';

import {
  getRoleGroupList,
  getRoleList,
  updateRole,
  getRoleDetail
} from '../../api/role';

interface StateType {
  roleList?: any; // 员工角色列表
}
@StoreDecorator
@AutoLoading
class StoreModule {
  public state() {
    return {
      roleList: {}
    };
  }

  // 编辑员工角色
  @Action()
  public async updateRole(state: StateType, payload: any) {
    return await updateRole(payload);
  }

  // 获取员工角色详情
  @Action()
  public async getRoleDetail(state: StateType, payload: any) {
    return await getRoleDetail(payload);
  }

  // 获取员工角色组列表
  @Action()
  public async getRoleGroupList({ commit, state }: any, option: any) {
    return await getRoleGroupList(option);
  }

  // 获取员工角色列表
  @Action('setRoleList')
  public async getRoleList({ commit, state }: any, option: any) {
    return await getRoleList(option);
  }

  // 设置员工角色列表
  @Mutation('roleList')
  public setRoleList(state: StateType, payload: any) {
    return payload;
  }

  // 员工角色列表
  @Getter
  public roleList(state: StateType) {
    return state.roleList;
  }
}

export default new StoreModule();
